// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__4INnK","content":"Modal_content__wDCRy","show":"Modal_show__KlipB","backdrop":"Modal_backdrop__sN11z"};